module.exports = __webpack_public_path__ + "img/linkedin.4a8858e0.svg";